<template>
    <div class="page">
        <div class="top">
            <div class="top-back" @click="black">
                <img src="@/assets/newUser/12.png" alt="">
            </div>
            <div class="top-name">常见问题</div>
        </div>
        <template v-if="inx === '1'">
            <div class="gtr1">卡号是什么</div>
            <div class="gtr2">卡背面上短小的数字就是卡号，后期咨询问题，只需提供卡上数字+问题，联系在线客服即可。</div>
        </template>
        <template v-if="inx === '2'">
            <div class="gtr1">实名认证</div>
            <div class="gtr2">随卡会有详细的操作说明，如操作实名遇到问题，请将卡号+所操作步骤显示截图一并发给在线客服，会有专业客服为您解答。</div>
        </template>
        <template v-if="inx === '3'">
            <div class="gtr1">实名认证卡号错误</div>
            <div class="gtr2">在联通小程序直接粘贴号码，不要手动输入或者是更改。</div>
        </template>
        <template v-if="inx === '4'">
            <div class="gtr1">怎么充值</div>
            <div class="gtr2">登录APP之后，可以进入对应卡，自行选择套餐订购充值。</div>
        </template>
        <template v-if="inx === '5'">
            <div class="gtr1">上不了网（联通卡新用户）</div>
            <div class="gtr2">
                请先确认一下是否实名认证成功，订购套餐是否到账，如已实名订购套餐无法使用，请按照以下步骤操作，设置之后即可使用<br/>
                第一步：点击手机设置。<br/>
                第二步：点击移动网络。<br/>
                第三步：点击接入点名称（APN）。<br/>
                第四步：点击新增接入点。APN名称：scuiotAPN：scuiot开启飞行模式在关闭或者是手机重启。<br/>
            </div>
        </template>
        <template v-if="inx === '6'">
            <div class="gtr1">怎么查询流量</div>
            <div class="gtr2">登录APP进入对应的设备/卡之后，可显示已用流量，总流量，剩余天数等，剩余天数小于等于5天的时候，请及时订购次月套餐。</div>
        </template>
        <template v-if="inx === '7'">
            <div class="gtr1">怎么订购次月套餐，充值多笔套餐不显示</div>
            <div class="gtr2">基础套餐是按月生效，每个账期只生效一笔，多次订购会按照账期顺延，可以在充值记录查询每笔套餐生效到期时间，当前账期若没有基础套餐，订购之后都是默认当前账期。</div>
        </template>
        <template v-if="inx === '8'">
            <div class="gtr1">充值了怎么不显示，无法上网</div>
            <div class="gtr2">请先确认充值的是否是余额，如是余额，请点击套餐购买，用余额付款即可，流量到账之后可以使用，如订购多笔套餐，可以去充值记录查询。</div>
        </template>
        <template v-if="inx === '9'">
            <div class="gtr1">无法上网（已用一段时间）</div>
            <div class="gtr2">拔插动卡/换手机，卡重新放好之后，联系客服提供卡号复机，即可恢复使用查询流量是否超出，负数超出之后，订购加餐包30分钟之后或者是下个账期恢复使用剩余天数小于等于5天，订购次月基础套餐成功30分钟之后即可恢复。</div>
        </template>
        <template v-if="inx === '10'">
            <div class="gtr1">怎么联系客服</div>
            <div class="gtr2">点击右下角我的----在线客服。</div>
        </template>
    </div>
</template>
<script>
export default{
    data(){
        return{
            inx:'0'
        }
    },
    created(){
        this.inx = this.$route.query.id
    },
    methods:{
         black(index){
            this.$router.push({
                path: "/newUser/problem",
            });
        },
        toBuyPkg(){
            this.$router.push({
                path: "/newUser/recharge",
                query: {
                    iccid: this.$store.state.iccid,
                },
            });
        },
    },
}
</script>
<style lang="less" scoped>
div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	height:100%;
	background: #f7f8fa;
    .top{
        flex-direction: row;
        align-items: center;
        height: 60px;
        background-color: #ffffff;
        .top-back{
            width:60px;
            align-items: center;
            text-align: center;
            position: absolute;
            height: 60px;
            line-height: 60px;
            justify-content: center;
            img{
                width:20px;
                height:20px;
            }
        }
        .top-name{
            text-align: center;
            font-size: 17px;
            color: #06121e;
            flex: 1 1 0%;
            font-weight: bold;
        }
    }
    .gtr1{
        line-height: 30px;
        font-size: 22px;
        font-weight: 800;
        color: #06121E;
        padding: 16px 23px 0 16px;
    }
    .gtr2{
        line-height: 23px;
        font-size: 16px;
        font-weight: 400;
        color: #8C9198;
        padding: 16px 23px 0 16px;
    }
}
</style>
